"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _NonFlippingGenericTiles = _interopRequireDefault(require("../../src/common/components/DrupalTiles/NonFlippingGenericTiles"));

var _ErvNestedTiles = _interopRequireDefault(require("../../src/common/components/DrupalTiles/ErvNestedTiles.scss"));

var _TargetShield = _interopRequireDefault(require("../../src/common/components/DrupalTiles/ErgoZep/TargetShield"));

var _NewsFeed = _interopRequireDefault(require("../../src/common/components/DrupalTiles/ErgoProthek/NewsFeed"));

var _StringHelper = _interopRequireDefault(require("../../src/helpers/StringHelper"));

var _KESI2Helper = _interopRequireDefault(require("../../src/KESI2/KESI2Helper"));

var _MuiAlertHelper = require("../../src/helpers/MuiAlertHelper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var NonFlippingTiles = /*#__PURE__*/function (_NonFlippingGenericTi) {
  (0, _inherits2["default"])(NonFlippingTiles, _NonFlippingGenericTi);

  var _super = _createSuper(NonFlippingTiles);

  function NonFlippingTiles() {
    (0, _classCallCheck2["default"])(this, NonFlippingTiles);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(NonFlippingTiles, [{
    key: "closingTile",
    value: function closingTile() {
      (0, _MuiAlertHelper.showAlertWithOptions)({
        message: 'onClose!',
        title: 'Title!',
        showCloseButton: true
      });
    }
  }]);
  return NonFlippingTiles;
}(_NonFlippingGenericTiles["default"]);

var _default = NonFlippingTiles;
exports["default"] = _default;